import React from "react";

const faq9 = () =>{
  return(
    <>
      <p>
        Se Flik: <u>Fält & Rubriker/Arbetade tim./st.</u>
      </p>
      
    </>
  );
}
export default faq9;